"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentPropertiesManipulator = void 0;
var tslib_1 = require("tslib");
var default_tab_width_1 = require("../changes/model/default-tab-width");
var different_odd_and_even_pages_1 = require("../changes/model/different-odd-and-even-pages");
var page_color_1 = require("../changes/model/page-color");
var base_manipulator_1 = require("./base-manipulator");
var DocumentPropertiesManipulator = (function (_super) {
    tslib_1.__extends(DocumentPropertiesManipulator, _super);
    function DocumentPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentPropertiesManipulator.prototype.setDefaultTabWidth = function (documentModel, newDefaultTabWidth) {
        var oldValue = documentModel.defaultTabWidth;
        documentModel.defaultTabWidth = newDefaultTabWidth;
        this.modelManipulator.notifyModelChanged(new default_tab_width_1.DefaultTabWidthModelChange(newDefaultTabWidth));
        return oldValue;
    };
    DocumentPropertiesManipulator.prototype.changePageColor = function (documentModel, newPageColor) {
        var oldValue = documentModel.pageBackColor;
        documentModel.setPageColor(newPageColor);
        this.modelManipulator.notifyModelChanged(new page_color_1.PageColorModelChange(newPageColor));
        return oldValue;
    };
    DocumentPropertiesManipulator.prototype.changeDifferentOddAndEvenPages = function (documentModel, newValue) {
        var oldValue = documentModel.differentOddAndEvenPages;
        documentModel.differentOddAndEvenPages = newValue;
        this.modelManipulator.notifyModelChanged(new different_odd_and_even_pages_1.DifferentOddAndEvenPagesModelChange(newValue));
        return oldValue;
    };
    return DocumentPropertiesManipulator;
}(base_manipulator_1.BaseManipulator));
exports.DocumentPropertiesManipulator = DocumentPropertiesManipulator;
